import * as React from 'react';
import {
    Link,
    Dialog, DialogTitle, DialogActions, Button
} from '@mui/material';

export interface LinkWithDetailsProps {
    text: string;
    title: string;
    children: React.ReactNode;
}

export default function LinkWithDetails(props: LinkWithDetailsProps) {
    const { text, title, children} = props;
    const [open, setOpen] = React.useState(false);
    
    const handleCloseDetails = () => {
        setOpen(false);
    };

    const handleOpenDetails = () => {
        setOpen(true);
    };
    
    return (
        <React.Fragment>
            <Dialog onClose={handleCloseDetails} open={open} maxWidth="xs" fullWidth={true}>
                <DialogTitle>{title}</DialogTitle>
                {children}
                <DialogActions>
                    <Button onClick={handleCloseDetails} color="primary">
                        Lukk
                    </Button>
                </DialogActions>
            </Dialog>
            <Link onClick={handleOpenDetails}>{props.text}</Link>
        </React.Fragment>
    );
}
